export const RAG_ERROR_CODES = {
	0: { langKey: 'team_not_found', toastLevel: 'error' },
	1: { langKey: 'team_not_active', toastLevel: 'warn' },
	2: { langKey: 'user_not_found', toastLevel: 'error' },
	3: { langKey: 'user_not_active', toastLevel: 'warn' },
	4: { langKey: 'quota_exceeded', toastLevel: 'warn' },
	5: { langKey: 'quota_not_found', toastLevel: 'error' },
	6: { langKey: 'tier_not_found', toastLevel: 'error' },
};
